import { makeStyles, createStyles } from '@material-ui/core/styles';

const RoomOptionsSidebarItemStyles = makeStyles((theme: any) => createStyles({
  roomItemHolder: {
    width: "100%",
    position: "relative",
    height: 50,
    backgroundColor: theme.palette.controlCenterButton.main,
    marginBottom: 5,
    overflow: "hidden"
  },
  roomOptionName: {
    fontWeight: 400,
    fontSize: 16,
    position: "relative",
    top: 15,
    left: 10,
    color: theme.palette.text.primary,
    overflow: "hidden",
    maxWidth: 174,
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    textAlign: "left",
  },
  changeRoomIconButton: {
    padding: 6,
    position: "relative",
  },
  peopleIcon: {
    color: theme.palette.roomTabIcon.main,
    position: "relative",
    fontSize: 20,
  },
  roomOptionCount: {
    fontSize: 16,
    position: "relative",
    top: 1,
  }
})
)

export { RoomOptionsSidebarItemStyles };